import { render, staticRenderFns } from "./left.vue?vue&type=template&id=3682854b&scoped=true"
import script from "./left.vue?vue&type=script&lang=js"
export * from "./left.vue?vue&type=script&lang=js"
import style0 from "./left.vue?vue&type=style&index=0&id=3682854b&prod&scoped=true&lang=scss"
import style1 from "./left.vue?vue&type=style&index=1&id=3682854b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3682854b",
  null
  
)

export default component.exports